import React, { useEffect, useState, useRef } from 'react';
import ApiService from '../../../services/apiService';
import { ClipLoader, PropagateLoader } from 'react-spinners';
import Tooltip from '../tooltip';

const RequisitionItemList = ({ onRequisitionData, itemData, selectedLocation, precision }) => {
    const [itemRows, setItemRows] = useState([]);
    const [loader, setLoader] = useState(true);
    const apiService = new ApiService();

    useEffect(() => {
        const getItems = async () => {
            try {
                setLoader(true)
                const formattedRowsPromises = itemData?.prDetails.map(async (detail, index) => {

                    const selecteditem = await apiService.getApiParamater('GET_ITEM', `?Warehouse=${selectedLocation?.label}&itemNo=${detail?.itemCode}`);
                    let selectItem = selecteditem?.data?.result[0]
                    return {
                        requisitionNo: detail.requisitionNo,
                        srno: detail.srno,
                        itemNo: detail.itemCode,
                        recordId: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        qty: detail.qty,
                        uom: detail.uom,
                        baseQty: selectItem.convToInvUOM * detail.qty,
                        convRate: selectItem.convToInvUOM,
                        baseAmount: detail?.unitPrice?.toFixed(precision || 3) || 0,
                        specification: detail.specification,
                        amount: detail?.amount?.toFixed(precision || 3),
                        stock: (selectItem?.stock / selectItem.convToInvUOM)?.toFixed(2),
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsPromises);
                if (formattedRows.length > 0) {
                    setLoader(false)
                    setItemRows(formattedRows)
                }
            } catch (error) {
                setLoader(false)
                console.error('Error fetching items:', error);
            }
        };
        if (itemData) {
            getItems();
        }
    }, [itemData]);
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            {loader === true ?
                <div className='center'>
                    <PropagateLoader color="#6E5199" size={20} />
                </div>
                :
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            {/* <th>Unit Price</th> */}
                            {/* <th>Amount</th> */}
                            {/* <th>Stock</th> */}
                            <th>BalForPo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(itemRows) && itemRows?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.srno} style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'>
                                    <Tooltip text={row.itemNo}>
                                        <input className='p-2' disabled value={row.itemNo} />
                                    </Tooltip>
                                </td>
                                <td className='m-0 p-0'>
                                    <Tooltip text={row.itemDescription}>
                                        <input className='p-2' disabled value={row.itemDescription} />
                                    </Tooltip>
                                </td>
                                <td className='m-0 p-0'>
                                    <Tooltip text={row.specification}>
                                        <input className='p-2' disabled value={row.specification} style={{ width: "250px" }} />
                                    </Tooltip>
                                </td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.baseQty} style={{ width: "150px" }} /></td>
                                {/* <td className='m-0 p-0'><input className='p-2' disabled value={row.baseAmount} style={{ width: "130px" }} /></td> */}
                                {/* <td className='m-0 p-0'><input className='p-2' disabled value={row.amount} style={{ width: "130px" }} /></td> */}
                                {/* <td className='m-0 p-0'><input className='p-2' disabled value={row.stock} style={{ width: "130px" }} /></td> */}
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.bol} style={{ width: "200px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        </div>
    );
};

export default RequisitionItemList;
